<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'Login',
  mounted () {
    window.location.href = '/api/v1/auth/loginRedirect'
  }
}
</script>

<style>
</style>
